import { modals } from '@mantine/modals';

export function openBuyerProfileSubscriptionModal({
  participationURL,
  tenderId,
}: {
  participationURL?: string;
  tenderId: number;
}) {
  modals.openContextModal({
    modal: 'buyerProfileSubscription',
    innerProps: {
      buyerProfileParticipationURL: participationURL,
      tenderId,
    },
    size: '480px',
    radius: 'lg',
    padding: '04',
  });
}
